import { defineStore } from 'pinia';
import ProjectsService from '@/Services/ProjectsService';
import { apiClient } from '@/Clients/ApiClient.js';

const projectService = new ProjectsService(apiClient);

export const useProjectAdditionalInfoStore = defineStore(
    'projectAdditionalInfo',
    {
        state: () => ({
            projectAdditionalInfo: null,
        }),
        actions: {
            async loadProjectAdditionalInfo(projectId) {
                if (!this.projectAdditionalInfo || this.projectAdditionalInfo.projectID !== projectId) {
                    await this.refreshProjectAdditionalInfo(projectId);
                }
                return this.projectAdditionalInfo;
            },
            resetProjectAdditionalInfo() {
                this.projectAdditionalInfo = null;
            },
            async refreshProjectAdditionalInfo(projectId) {
                try {
                    const response = await projectService.getProjectAdditionalInfo(projectId);
                    this.projectAdditionalInfo = response.data;
                    return this.projectAdditionalInfo;
                }
                catch (error) {
                    throw new Error(error);
                }
            },
        },
        getters: {
            projectSubmissionEntryID() {
                return this.projectAdditionalInfo?.currentSubmissionEntry?.projectSubmissionEntryID || null;
            },
        },
    });
